
export const DEFAULT_DURATION = 3000;
export const DEFAULT_SUCCESS_DURATION = 2000;
export const DEFAULT_ERROR_DURATION = 3500;
export const DEFAULT_STORE_NAME = 'globalToastMessages';

export const TOAST_TYPE_SUCCESS = 'SUCCESS';
export const TOAST_TYPE_WARNING = 'WARNING';
export const TOAST_TYPE_DANGER = 'DANGER';
export const TOAST_TYPE_INFO = 'INFO';
